// 業務管理アシスタントの状態。会話はサーバ保存（AssistantConversation）。パネルの開閉と現在の会話を保持する。
import { defineStore } from "pinia";
import { ref } from "vue";

export const useBizhubAssistantStore = defineStore("bizhubAssistant", () => {
  const open = ref(false);
  const conversationId = ref(null);
  const messages = ref([]); // { id?, role, content, streaming?, rating?, recorded?: boolean }
  // 送信中フラグ。パネルは閉じると破棄されるので、再マウントしても二重送信できないよう store が持つ。
  const streaming = ref(false);

  function newConversation() {
    if (streaming.value) return;
    conversationId.value = null;
    messages.value = [];
  }

  async function loadConversation(id) {
    if (streaming.value) throw new Error("返信の生成中です。完了してからもう一度お試しください");
    const { getConversation } = await import("@/api/bizhubApi");
    const c = await getConversation(id);
    conversationId.value = c.id;
    messages.value = (c.messages || []).map((m) => ({
      id: m.id, role: m.role, content: m.content, rating: m.rating || "",
      recorded: (m.tool_calls || []).some((t) => t.name === "record_feedback" && t.ok),
      opened: (m.tool_calls || []).some((t) => t.name === "open_screen" && t.ok) ? "画面" : "",
    }));
    open.value = true;
  }

  return { open, conversationId, messages, streaming, newConversation, loadConversation };
});
